import gsap from "gsap"
import { useEffect, useRef } from "react"
import chanceImage from "@/images/chance-card-image.webp"
import chestImage from "@/images/chest-card-image.webp"
import classNames from "classnames"
import { drawCard } from "@/utils/animationHelpers"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { setGlobalElement } from "@/store/globalSlice"
import monopolyMan from "@/images/trade-accepted.webp"

import communityChestBackgroud from "@/images/backgrounds/community-chest-bg.webp"
import { images } from "@/utils/data"
import { isMobile } from "@/utils/utils"

interface ChanceProps {
  chance: IBonusCard
  index: number
  isChance?: boolean
}

const Chance: React.FC<ChanceProps> = ({ chance, index, isChance }) => {
  const cardRef = useRef<HTMLDivElement>(null)
  const dispatch = useAppDispatch()
  const elements = useAppSelector((state) => state.global.elements)

  useEffect(() => {
    if (cardRef.current && isChance) {
      const previousElm = elements.chanceCards.find(
        (chanceCard) => chanceCard.id === chance.id
      )
      if (previousElm) return
      dispatch(
        setGlobalElement({
          chanceCards: [
            ...elements.chanceCards,
            { id: chance.id, element: cardRef.current },
          ],
        })
      )
    }
    if (cardRef.current && !isChance) {
      const previousElm = elements.communityChestCards.find(
        (chanceCard) => chanceCard.id === chance.id
      )
      if (previousElm) return
      dispatch(
        setGlobalElement({
          communityChestCards: [
            ...elements.communityChestCards,
            { id: chance.id, element: cardRef.current },
          ],
        })
      )
    }
  }, [
    elements.chanceCards,
    elements.communityChestCards,
    isChance,
    chance.id,
    dispatch,
  ])

  const margin = isMobile() ? 0.75 : 1.3
  return (
    <>
      <div className="card-container absolute ">
        <div
          data-testid={`game.${isChance ? "chance" : "community-chest"}-${chance.id
            }`}

          className={classNames("card bg-[#eacea3]", {
            chance: isChance,
            chest: !isChance,
          })}
          style={{
            // Keep all cards aligned neatly, with subtle offset
            transform: "rotateZ(-90deg)",
            marginTop: `-${index * margin}px`,
            marginLeft: `-${index * margin}px`,
            zIndex: 100 - index, // Ensure proper stacking
          }}
          ref={cardRef}
        >
          <div
            className="card-back bg-[#e2c6a6] bg-gradient-to-br from-[#e2c6a6] to-[#d8bfa4] border-white"
            style={{
              // boxShadow: "0px 4px 10px rgba(0,0,0,0.4)", // Consistent, subtle shadow
              backgroundImage: `url(${isChance ? images.actionCardBack : images.eventCardBack
                })`,
              backgroundSize: "cover",
            }}
          >
            {/* {isChance ? (
              <img
                className=""
                src={images.actionCardBack}
                alt="Chance Card Front"
              />
            ) : (
              <img className="" src={chestImage} alt="Chance Card Front" />
            )} */}
          </div>
          <div className="card-front  ">
            {/* <div className="border-black border"> */}
            <img
              className="w-full h-full object-cover none   p-0 "
              src={images.cards[chance.id]}
              alt="Chance Card Front"
            />
            {/* </div> */}

            {/* <div className="flex items-center justify-around flex-col h-full w-full border-black border relative  md:p-0">
              <div
                className={classNames(
                  "text-chest-back font-poppins font-medium absolute top-0 left-1/2 bg-white  -translate-y-1/2 -translate-x-1/2 text-[0.5rem] px-1 ",
                  { "text-chance-back": isChance }
                )}
              >
                {isChance ? "Action" : "Event card"}
              </div> */}
            {/* <div className="relative w-full flex justify-center"> */}
            {/*   <div className="bg-chest-back text-white font-poppins  w-4/5 text-center text-[11px]  px-5 "> */}
            {/*     Community chest */}
            {/*   </div> */}
            {/**/}
            {/*   <img */}
            {/*     src={monopolyMan} */}
            {/*     className="h-6 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-3/4" */}
            {/*   /> */}
            {/* </div> */}
            {/* <p className="font-primary text-center text-xs md:text-base">
                {chance.text}
              </p> */}
            {/* <div className="text-[8px] text-black font-poppins absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-white px-1">
                Monopoly
              </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  )
}

export default Chance
